/**
 * StudentTabLayout — ce qui entoure la page d'un onglet de l'élève : le fond du thème (la lueur sur
 * l'accueil seulement) et l'en-tête de l'espace. Le pendant de `ParentTabScreenWrapper` +
 * `ParentTabBackground`, sans legacy à garder : ce fond n'existe que du côté design system.
 *
 * Le header du DS ne pose aucune surface : c'est ce fond qu'on voit derrière lui.
 */
import React from "react"

import { ScreenBackground } from "../../../../../design-system"
import { StudentShellHeader } from "./StudentShellHeader"

export type StudentTabLayoutProps = {
    /** L'onglet est l'accueil : la lueur, et pas de compteurs dans l'en-tête. */
    home?: boolean
    children: React.ReactNode
}

export function StudentTabLayout(props: StudentTabLayoutProps) {
    const { home = false, children } = props

    return (
        <ScreenBackground glow={home}>
            <StudentShellHeader onHome={home} />
            {children}
        </ScreenBackground>
    )
}
